export const normalizeTerms = function normalizeTerms(text) {
  var dictionary = {
    'night eye': 'Night Guard',
    '\u10DC\u10D0\u10D8\u10D7 \u10D0\u10D8': 'Night Guard',
    'NE': 'Night Guard',
    '\u10DC\u10D8\u10EC\u10D8': 'Night Guard',
    'RCT': 'Root Canal Treatment',
    '\u10D4\u10DC\u10D3\u10DD': 'Root Canal Treatment',
    'root canal': 'Root Canal Treatment',
    '\u10D9\u10DD\u10DB\u10DE': 'Composite Filling',
    'composite': 'Composite Filling',
    '\u10D1\u10DF\u10D4\u10DC\u10D8': 'Composite Filling',
    '\u10D9\u10DD\u10DB\u10DE\u10DD\u10D6\u10D8\u10E2\u10D8': 'Composite Filling',
    '\u10D4\u10E5\u10E1\u10E2\u10E0\u10D0\u10E5\u10EA\u10D8\u10D0': 'Extraction',
    'extraction': 'Extraction',
    '\u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10D0': 'Extraction',
    '\u10D8\u10DB\u10DE\u10DA': 'Implant',
    'implant': 'Implant',
    '\u10D8\u10DB\u10DE\u10DA\u10D0\u10DC\u10E2\u10D8': 'Implant',
    '\u10DE\u10E0\u10DD\u10D7\u10D4\u10D6\u10D8': 'Prosthesis',
    'denture': 'Prosthesis',
    '\u10D2\u10D5\u10D8\u10E0\u10D2\u10D5\u10D8\u10DC\u10D8': 'Crown',
    'crown': 'Crown',
    '\u10D5\u10D8\u10DC\u10D8\u10E0\u10D8': 'Veneer',
    'veneer': 'Veneer',
    '\u10E1\u10D9\u10D4\u10D8\u10DA\u10D8\u10DC\u10D2\u10D8': 'Scaling',
    'scaling': 'Scaling',
    '\u10EC\u10DB\u10D4\u10DC\u10D3\u10D0': 'Professional Cleaning',
    'cleaning': 'Professional Cleaning',
    '\u10D2\u10D0\u10D7\u10D4\u10D7\u10E0\u10D4\u10D1\u10D0': 'Whitening',
    'whitening': 'Whitening',
    '\u10D1\u10E0\u10D4\u10D9\u10D4\u10E2\u10D8': 'Braces',
    'braces': 'Braces',
    '\u10DD\u10E0\u10D7\u10DD': 'Orthodontic Treatment',
    'ortho': 'Orthodontic Treatment',
    '\u10DE\u10D0\u10DC\u10DD\u10E0\u10D0\u10DB\u10D0': 'Panoramic X-ray',
    'OPG': 'Panoramic X-ray',
    '\u10DE\u10D4\u10E0\u10D8\u10D0\u10DE\u10D8\u10D9\u10D0\u10DA\u10E3\u10E0\u10D8': 'Periapical X-ray',
    'PA': 'Periapical X-ray',
    'CBCT': 'Cone Beam CT',
    '\u10D9\u10D0\u10E2\u10D4': 'Cone Beam CT'
  }

  var changes = []
  var normalized = text

  // Sort keys by length descending so longer matches take priority
  var keys = Object.keys(dictionary).sort(function (a, b) {
    return b.length - a.length
  })

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i]
    var regex = new RegExp('\\b' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'gi')
    var match
    while ((match = regex.exec(normalized)) !== null) {
      if (match[0].toLowerCase() !== dictionary[key].toLowerCase()) {
        changes.push({
          original: match[0],
          normalized: dictionary[key],
          position: match.index
        })
      }
    }
  }

  // Apply replacements from end to start to preserve positions
  changes.sort(function (a, b) { return b.position - a.position })
  for (var j = 0; j < changes.length; j++) {
    var c = changes[j]
    normalized = normalized.slice(0, c.position) + c.normalized + normalized.slice(c.position + c.original.length)
  }

  // Re-sort changes by position ascending for output
  changes.sort(function (a, b) { return a.position - b.position })

  return { normalized: normalized, changes: changes }
}
